import { render, staticRenderFns } from "./SProvider.vue?vue&type=template&id=717a59db"
import script from "./SProvider.vue?vue&type=script&lang=js"
export * from "./SProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports